"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[620],{

/***/ 5996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Recommendations; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _SingleArticle_SingleArticle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1081);



function Recommendations(param) {
    let { data , title , link  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "recommendation_container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "recommendation_articles",
                children: data === null || data === void 0 ? void 0 : data.map((p, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SingleArticle_SingleArticle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        link: link,
                        data: p
                    }, i))
            })
        ]
    });
}


/***/ }),

/***/ 9451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DiscoverBeneBono; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8945);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8287);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3376);






function DiscoverBeneBono() {
    const [userEmail, setUserEmail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [isEmpty, setIsEmpty] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isSend, setIsSend] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [lang, setLang] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLang(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    const susbcriptionNewsLetter = ()=>axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .Z.post("https://eo2uod9d6ddkieu.m.pipedream.net", {
            userEmail,
            lang
        }).then((res)=>{
            if (res) {
                setIsSend(true);
            }
        }).catch((error)=>{
            console.log(error);
        });
    function handleChange(e) {
        setUserEmail(e.target.value);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "discover_container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("discover.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        children: t("discover.first.subtitle")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("discover.first.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        children: t("discover.second.subtitle")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("discover.second.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        children: t("discover.third.subtitle")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("discover.third.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/checkout",
                className: "button",
                children: t("button.baskets")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("newsletter.title")
            }),
            !isSend ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("newsletter.description")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        onChange: handleChange,
                        type: "email",
                        placeholder: "manuel@exemple.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "button",
                        onClick: ()=>{
                            if (userEmail) {
                                susbcriptionNewsLetter();
                            }
                            if (!userEmail) {
                                setIsEmpty(true);
                            }
                        },
                        children: t("newsletter.button")
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "success_newsletter",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .HandCheck */ .zG, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: t("newsletter.already.subscribe")
                    })
                ]
            }),
            isEmpty && !isSend ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    color: "red",
                    margin: 0,
                    marginTop: "5px",
                    paddingLeft: "10px"
                },
                children: t("email.error.format")
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("socials.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: t("socials.description")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "socials_container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Instagram */ .mr, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Facebook */ .s1, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Linkedin */ .n6, {})
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 61:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8287);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3376);





function Footer(param) {
    let { links , locale  } = param;
    const { t  } = useTranslation();
    const lang = locale || "fr";
    return /*#__PURE__*/ _jsxs("div", {
        className: "footer",
        children: [
            /*#__PURE__*/ _jsxs("h2", {
                children: [
                    t("footer.title.1"),
                    /*#__PURE__*/ _jsx("br", {}),
                    " ",
                    t("footer.title.2"),
                    " ",
                    /*#__PURE__*/ _jsx("br", {}),
                    " ",
                    t("footer.title.3"),
                    " ",
                    /*#__PURE__*/ _jsx(FooterHeadingHand, {})
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "footer_links_page",
                children: links.map((l, i)=>/*#__PURE__*/ _jsx("a", {
                        href: l.href,
                        children: l.label
                    }, i))
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: "footer_company_info",
                children: [
                    /*#__PURE__*/ _jsxs("li", {
                        children: [
                            "Bene Bono\xae ",
                            new Date().getFullYear()
                        ]
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: lang !== "es" && "https://static.horsnormes.co/static/legal/20220224-BeneBono-Politique-De-Confidentialite.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.privacynotice")
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: lang !== "es" ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf" : "https://static.horsnormes.co/static/legal/CGV-spain.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.conditionsofuse")
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.legal_mentions")
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: t("footer.cookies")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LogoFooter, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "footer_socials",
                children: [
                    /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                        children: /*#__PURE__*/ _jsx(Instagram, {})
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                        children: /*#__PURE__*/ _jsx(Facebook, {})
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                        children: /*#__PURE__*/ _jsx(Linkedin, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "footer_benebono_info",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.email")
                            }),
                            lang === "es" && /*#__PURE__*/ _jsx("p", {
                                children: t("footer.openhour")
                            }),
                            lang === "es" && /*#__PURE__*/ _jsx("p", {
                                children: t("footer.phonenumber")
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.address")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.certification")
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: t("footer.certification.code")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RefreshedFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7421);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3376);



function RefreshedFooter(param) {
    let { links , locale  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const lang = locale || "fr";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "footer_title",
                children: t("footer.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_socials",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle facebook",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoFacebook */ .To, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoInstagram */ .yR, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_socials__circle",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .BenebonoLinkedin */ .f8, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "footer_links",
                children: links.map((l, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: l.href,
                        children: l.label
                    }, i))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_third_row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "footer_company_info",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    "Bene Bono\xae ",
                                    new Date().getFullYear()
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: lang !== "es" && "https://static.horsnormes.co/static/legal/20220224-BeneBono-Politique-De-Confidentialite.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.privacynotice")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: lang !== "es" ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf" : "https://static.horsnormes.co/static/legal/CGV-spain.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.conditionsofuse")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf",
                                target: "_blank",
                                rel: "noreferrer",
                                children: t("footer.legal_mentions")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: t("footer.cookies")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer_logo",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_2__/* .LogoFooter */ .vP, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "footer_address",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "addresses",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.email")
                                    }),
                                    lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.openhour")
                                    }),
                                    lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.phonenumber")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.address")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "certification",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.certification")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("footer.certification.code")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function ShareButton(param) {
    let { icon , text , href  } = param;
    return /*#__PURE__*/ _jsxs("a", {
        href: href,
        className: "share_button",
        children: [
            icon,
            text
        ]
    });
}


/***/ }),

/***/ 1081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SingleArticle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);




dayjs__WEBPACK_IMPORTED_MODULE_3___default().locale("fr");
function SingleArticle(param) {
    let { data , link  } = param;
    var _data_attributes_preview_image_data_, _data_attributes, _data_attributes_preview_image, _data_attributes_preview_image_data__attributes, _data_attributes_tags_data_, _data_attributes_tags, _data_attributes1, _data_attributes2, _data_attributes3, _data_attributes4, _data_attributes5;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "recommendation_article",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                data.attributes.preview_image.data != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (_data_attributes_preview_image_data_ = (_data_attributes = data.attributes) === null || _data_attributes === void 0 ? void 0 : (_data_attributes_preview_image = _data_attributes.preview_image) === null || _data_attributes_preview_image === void 0 ? void 0 : _data_attributes_preview_image.data[0]) === null || _data_attributes_preview_image_data_ === void 0 ? void 0 : (_data_attributes_preview_image_data__attributes = _data_attributes_preview_image_data_.attributes) === null || _data_attributes_preview_image_data__attributes === void 0 ? void 0 : _data_attributes_preview_image_data__attributes.url
                }) : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: (_data_attributes_tags_data_ = (_data_attributes_tags = data.attributes.tags) === null || _data_attributes_tags === void 0 ? void 0 : _data_attributes_tags.data[0]) === null || _data_attributes_tags_data_ === void 0 ? void 0 : _data_attributes_tags_data_.attributes.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(link, "/").concat(data === null || data === void 0 ? void 0 : (_data_attributes1 = data.attributes) === null || _data_attributes1 === void 0 ? void 0 : _data_attributes1.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        children: data === null || data === void 0 ? void 0 : (_data_attributes2 = data.attributes) === null || _data_attributes2 === void 0 ? void 0 : _data_attributes2.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "article_info",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: data === null || data === void 0 ? void 0 : (_data_attributes3 = data.attributes) === null || _data_attributes3 === void 0 ? void 0 : _data_attributes3.author
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: dayjs__WEBPACK_IMPORTED_MODULE_3___default()((_data_attributes4 = data.attributes) === null || _data_attributes4 === void 0 ? void 0 : _data_attributes4.publishedAt).format("DD MMMM YYYY")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: data === null || data === void 0 ? void 0 : (_data_attributes5 = data.attributes) === null || _data_attributes5 === void 0 ? void 0 : _data_attributes5.description
                })
            ]
        })
    }, data === null || data === void 0 ? void 0 : data.id);
}


/***/ })

}]);